// frontend_react/src/components/common/PasswordConfirmationModal.jsx

import { useState } from "react";
import styled from "styled-components";

export default function PasswordConfirmationModal({
  open,
  badge = "Administration - Action Critique",
  title = "Confirmation requise",
  message = "Cette action est irréversible. Veuillez confirmer avec votre mot de passe.",
  confirmLabel = "Confirmer",
  cancelLabel = "Annuler",
  loading = false,
  error = "",
  onConfirm,
  onCancel,
}) {
  const [password, setPassword] = useState("");

  if (!open) return null;

  const handleConfirm = () => {
    if (!password || loading) return;
    onConfirm?.(password);
  };

  return (
    <Overlay>
      <ModalCard>
        <Header>
          <SectionBadge>⚠️ Administration</SectionBadge>
          <div>
            <h3>{title}</h3>
            <p>{message}</p>
          </div>
        </Header>

        <Field>
          <label>Mot de passe utilisateur</label>
          <input
            type="password"
            autoFocus
            value={password}
            disabled={loading}
            onChange={(event) => setPassword(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter") handleConfirm();
              if (event.key === "Escape") onCancel?.();
            }}
          />
        </Field>

        {error && <ErrorMessage>{error}</ErrorMessage>}

        <Actions>
          <CancelButton type="button" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </CancelButton>

          <ConfirmButton
            type="button"
            onClick={handleConfirm}
            disabled={loading || !password}
          >
            {loading ? "Vérification..." : confirmLabel}
          </ConfirmButton>
        </Actions>
      </ModalCard>
    </Overlay>
  );
}

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: grid;
  place-items: center;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.62);
`;

const SectionBadge = styled.span`
  display: inline-block;
  width: fit-content;
  padding: 0.3rem 0.65rem;
  border-radius: 999px;
  background: #fff9ea;
  color: #0b1328;
  font-size: 0.72rem;
  font-weight: 950;
`;

const ModalCard = styled.div`
  width: min(440px, 100%);
  padding: 1rem;
  border-radius: 16px;
  background: #202a43;
  color: #f7f7f7;
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

const Header = styled.div`
  display: grid;
  gap: 0.45rem;
  margin-bottom: 1rem;

  h3 {
    margin: 0;
    color: #fff9ea;
    font-weight: 950;
  }

  p {
    margin: 0;
    opacity: 0.78;
    line-height: 1.45;
  }
`;

const DangerIcon = styled.div`
  font-size: 1.5rem;
`;

const Field = styled.div`
  display: grid;
  gap: 0.4rem;

  label {
    font-size: 0.78rem;
    opacity: 0.78;
    font-weight: 850;
  }

  input {
    width: 100%;
    min-height: 44px;
    border: none;
    border-radius: 12px;
    padding: 0.75rem;
    background: #fff9ea;
    color: #0b1328;
    font-weight: 850;
    box-sizing: border-box;
    outline: none;
  }
`;

const ErrorMessage = styled.div`
  margin-top: 0.8rem;
  padding: 0.75rem;
  border-radius: 12px;
  background: rgba(180, 40, 40, 0.92);
  color: white;
  font-weight: 850;
`;

const Actions = styled.div`
  display: flex;
  gap: 0.65rem;
  margin-top: 1rem;
`;

const CancelButton = styled.button`
  flex: 1;
  border: 1px solid rgba(255, 249, 234, 0.35);
  border-radius: 12px;
  padding: 0.95rem 1rem;
  background: transparent;
  color: #fff9ea;
  font-weight: 950;
  cursor: pointer;
`;

const ConfirmButton = styled.button`
  flex: 1;
  border: none;
  border-radius: 12px;
  padding: 0.95rem 1rem;
  background: rgba(180, 40, 40, 0.9);
  color: white;
  font-weight: 950;
  cursor: pointer;
`;